import EmblaCarousel from '@/components/EmblaCarousel';
import { useIsMobile } from '@/hooks/use-is-mobile';
import { cn } from '@/lib/utils';
import Image from 'next/image';
import Link from 'next/link';
// import Balancer from 'react-wrap-balancer';
const data = [
  {
    icon: 1,
    title: 'Rewards Program',
    description:
      'Experience a world of benefits with our Reward Program! As a member, you’ll receive exclusive birthday gifts to celebrate your special day, earn reward points that can be redeemed for discounts on future purchases, and take part in exciting field testing opportunities for our latest products. Plus, enjoy early access to pre-sales, so you’re among the first to explore our new collections.',
    link: '/advtr',
  },
  {
    icon: 2,
    title: 'Free Shipping',
    description: 'Enjoy free shipping on orders over a certain amount for a more convenient shopping experience.',
  },

  {
    icon: 3,
    title: 'Referral Discounts',
    description:
      'Share the love! Refer friends and family, and you’ll both receive a discount when your friend makes their first purchase.',
  },
  {
    icon: 4,
    title: 'Extended Return Policy',
    description:
      'We offer an extended return period of 45 days, giving you extra time to decide if your purchase is right for you.',
    link: '/shipping-return-policy',
  },
  {
    icon: 5,
    title: 'Personalized Support',
    description:
      'Our knowledgeable customer service team is always ready to help, whether you need guidance on product care, support with claims, or recommendations for the best fit.',
  },
];
const dataMobile = [
  {
    list: [data[0]],
  },
  {
    list: [data[1], data[4]],
  },
  {
    list: [data[2], data[3]],
  },
];
const OPTIONS = {
  containScroll: false,
  align: 'start',
};
export const SatisfactionData = () => {
  return (
    <div className=' grid grid-cols-3 gap-x-[35px] gap-y-[30px]'>
      {data.map((item, index) => (
        <div
          key={index}
          className={cn(
            'flex min-h-[340px] flex-col items-center  justify-start  gap-[10px] bg-[#F9F9F9]  p-[20px]',
            index === 0 && 'col-span-2',
          )}
        >
          <Image
            src={`/warranty-page/img${index + 1}.svg`}
            width={90}
            height={65}
            alt={item.title}
            className='h-[65px] w-[90px]'
          />

          <h3 className='text-center font-roboto-medium text-[20px] font-medium leading-[28px]'>{item.title}</h3>
          <p className=' font-roboto-light text-[16px] font-light leading-[26px]'>{item.description}</p>

          {item?.link && (
            <Link
              href={item.link}
              className='w-fit text-center font-roboto-medium text-[16px] font-medium underline lg_text-[18px]'
            >
              Learn More
            </Link>
          )}
        </div>
      ))}
    </div>
  );
};
export const SatisfactionDataMobile = () => {
  return (
    <div className='w-full px-[12px] pb-[20px]'>
      <EmblaCarousel
        slides={dataMobile}
        options={OPTIONS}
        classes={{
          emblaSlide: 'flex-[0_0_300px] mr-[10px]',
          emblaControls: 'hidden',
        }}
      >
        {(item, index) => (
          <div className='flex h-[470px] w-full flex-col items-start justify-start gap-[10px]'>
            {item.list.map((child, cIndex) => (
              <div
                key={cIndex}
                className={cn(
                  'flex flex-col items-center justify-start gap-[10px] bg-[#F9F9F9]',
                  child.icon === 1 ? 'col-span-2 h-full px-[12px] py-[30px]' : ' px-[12px] py-[15px]',
                  child.icon === 2 && 'py-[30px]',
                  child.icon === 4 && 'py-[25px]',
                )}
              >
                <Image
                  src={`/warranty-page/img${child.icon}.svg`}
                  width={55}
                  height={40}
                  className='h-[40px] w-[55px]'
                />

                <h3 className='text-center font-roboto-medium text-[18px] font-medium leading-[22px] lg_text-[20px] lg_leading-[28px]'>
                  {child.title}
                </h3>
                <p className=' font-roboto-light text-[16px] font-light leading-[26px]'>{child.description}</p>

                {child?.link && (
                  <Link
                    href={child.link}
                    className='w-fit text-center font-roboto-medium text-[16px] font-medium underline lg_text-[18px]'
                  >
                    Learn More
                  </Link>
                )}
              </div>
            ))}
          </div>
        )}
      </EmblaCarousel>
    </div>
  );
};
export const AdditionalBenefitsTowardsCustomerSatisfaction = () => {
  const { isDesktop } = useIsMobile();
  return (
    <div className='personalContent mx-auto mb-[40px] text-primary lg_mb-[80px]'>
      <h2
        id='customer-benefits'
        className='mb-[20px] px-[12px] font-teko-medium text-[28px] uppercase leading-[30px] lg_px-0 lg_text-[40px] lg_leading-[40px]'
      >
        Additional Benefits
      </h2>
      {isDesktop ? <SatisfactionData /> : <SatisfactionDataMobile />}

      {/* <div className='block pt-4 text-sm lg_hidden'>
        We value your trust and strive to make every interaction with Hisea a positive one. Your peace of mind is our
        priority!
      </div> */}
    </div>
  );
};
